(function () {
  function mountSection(config) {
    var SECTION_ID   = config.sectionId;
    var AUTOPLAY_ON  = config.autoplayOn;
    var AUTOPLAY     = config.autoplay;
    var GAP          = config.gap;
    var GAP_MOBILE   = config.gapMobile;
    var TOTAL        = config.total;

    var splideInstance = null;

    function destroyAndRemount() {
      var el = document.getElementById('splide-' + SECTION_ID);
      if (!el) return;
      if (splideInstance) {
        try { splideInstance.destroy(); } catch (e) {}
        splideInstance = null;
      }
      el.classList.remove('is-initialized');
      mountSplide(el);
    }

    function mountSplide(el) {
      var perPage = TOTAL >= 3 ? 3 : TOTAL;

      splideInstance = new Splide(el, {
        type        : TOTAL > 3 ? 'loop' : 'slide',
        perPage     : perPage,
        perMove     : 1,
        gap         : GAP,
        autoplay    : AUTOPLAY_ON,
        interval    : AUTOPLAY,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows      : false,
        pagination  : false,
        drag        : true,
        speed       : 600,
        breakpoints : {
          1024: {
            perPage: TOTAL >= 2 ? 2 : TOTAL,
            gap    : '12px'
          },
          767: {
            perPage  : 1,
            gap      : GAP_MOBILE,
            padding  : { left: '0px', right: '60px' },
            autoWidth: false
          }
        }
      });

      var dotsContainer = document.getElementById('fcc-dots-' + SECTION_ID);

      function updateActiveDot(activeIndex) {
        if (!dotsContainer) return;
        var allDots = dotsContainer.querySelectorAll('.fcc-dot');
        for (var j = 0; j < allDots.length; j++) {
          if (parseInt(allDots[j].getAttribute('data-index'), 10) === activeIndex) {
            allDots[j].classList.add('is-active');
          } else {
            allDots[j].classList.remove('is-active');
          }
        }
      }

      splideInstance.on('mounted', function () {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        for (var i = 0; i < TOTAL; i++) {
          var li  = document.createElement('li');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'fcc-dot';
          btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          btn.setAttribute('data-index', i);
          (function (index) {
            btn.addEventListener('click', function () {
              splideInstance.go(index);
            });
          })(i);
          li.appendChild(btn);
          dotsContainer.appendChild(li);
        }
        updateActiveDot(splideInstance.index);

        if (AUTOPLAY_ON) {
          var track = el.querySelector('.splide__track');
          if (track) {
            track.addEventListener('mouseenter', function () { splideInstance.Components.Autoplay.pause(); });
            track.addEventListener('mouseleave', function () { splideInstance.Components.Autoplay.play(); });
          }
        }
      });

      splideInstance.on('move',  function (newIndex) { updateActiveDot(newIndex); });
      splideInstance.on('moved', function (newIndex) { updateActiveDot(newIndex); });

      splideInstance.mount();
    }

    function initSplide() {
      var el = document.getElementById('splide-' + SECTION_ID);
      if (!el || el.classList.contains('is-initialized')) return;
      mountSplide(el);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSplide);
    } else {
      initSplide();
    }

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { destroyAndRemount(); }
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.detail && e.detail.sectionId === SECTION_ID) {
        setTimeout(destroyAndRemount, 150);
      }
    });

    document.addEventListener('shopify:block:select', function (e) {
      if (e.detail && e.detail.sectionId === SECTION_ID) {
        setTimeout(destroyAndRemount, 150);
      }
    });
  }

  function boot() {
    var configs = window.fccConfig || {};
    for (var id in configs) {
      if (Object.prototype.hasOwnProperty.call(configs, id)) {
        mountSection(configs[id]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();